import React from 'react';
import ProductsLoop from './ProductsLoop';
import FilterBar from './FilterBar';
import { ProductTypes } from '../../types/product/product';
import pages from '../../routes/pages';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApolloError, useQuery } from '@apollo/client';
import { GetProductsQuery } from '../../graphql/generated/graphql';
import QUERY_PRODUCTS from '../../graphql/query/product/products.query';
import { setProducts } from '../../store/actions/productFilter.action';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { getGoToPage } from '../../helpers/page/goToPage';
import { getProductTypesFromQuery } from '../../helpers/transformApiResponse/product';
import { AppState } from '../../store/reducers';
import { ContainerFullWidth } from '../../components/layouts/ContainerFullWidth';
import { FeatureContainer } from '../../components/molecules/Containers/FeatureContainer';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';
import useGoToPage from '../../hooks/useGoToPage';

const ReportingPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { ong } = useSelector((state: AppState) => state?.user);
  const goToNgo = useGoToPage(pages.NGO.path);

  const { loading, error } = useQuery<GetProductsQuery>(QUERY_PRODUCTS, {
    onCompleted: res => {
      dispatch(
        setProducts(res?.produits?.data.map(p => getProductTypesFromQuery(p)))
      );
    }
  });

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={new ApolloError(error)}
        text={error.message.replace('GraphQL error: Error:', '')}
      />
    );

  const toSingleProduct = getGoToPage<{ idProduit: string }>(history)(
    pages.PRODUCT_SINGLE_PAGE.path
  );

  return (
    <>
      {!ong && (
        <>
          <ContainerFullWidth>
            <FeatureContainer>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px'
                }}
              >
                <p>
                  Vous devez choisir une ONG pour accéder à votre catalogue
                  produits et faire votre reporting des ventes.
                  <span role="img" aria-label="emoji">
                    😄
                  </span>
                </p>
                <ButtonWithText
                  content="Je choisis mon ONG"
                  onClick={goToNgo}
                />
              </div>
            </FeatureContainer>
          </ContainerFullWidth>
        </>
      )}
      {ong && (
        <>
          <FilterBar />
          <ProductsLoop
            onClickNavigate={(idProduit: ProductTypes['id']) => () =>
              toSingleProduct({ idProduit })}
          />
        </>
      )}
    </>
  );
};

export default ReportingPage;
